import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM2CentresConfig} from './getAccountingMatrixDatagridM2CentresConfig';

export function AccountingMatrixDatagridM2Centres() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM2CentresConfig()} />;
}
